import { HTMLAttributes } from 'react'

import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import Section from '@/components/base/section'

import ImageParallax from '../base/image-parallax'
import { cn } from '@/lib/utils'

export type FullheightMediaProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    media: MediaElement
    variant: 'portrait' | 'square' | 'landscape'
    use_overlay: boolean
  }>

const FullheightMedia = ({
  media,
  variant,
  use_overlay,
  className,
  ...props
}: FullheightMediaProps) => {
  return (
    <Section className={cn('px-margin lg:px-0', className)} {...props}>
      <Grid>
        <div
          className={cn(
            'col-span-2 md:col-span-4 md:col-start-2',
            'lg:col-auto lg:row-span-12'
          )}
        >
          <div
            className={cn(
              'relative h-auto w-full lg:h-full',
              {
                'w-fullheight-media-portrait': variant === 'portrait',
                'w-fullheight-media-square': variant === 'square',
                'w-fullheight-media-landscape': variant === 'landscape'
              },
              {
                'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black/45':
                  use_overlay
              }
            )}
          >
            <ImageParallax disable={media?.use_video}>
              {(imageRef) => (
                <Media
                  ref={imageRef}
                  fit="cover"
                  className="h-auto w-full lg:h-full lg:w-full"
                  size="full"
                  {...media}
                />
              )}
            </ImageParallax>
          </div>
        </div>
      </Grid>
    </Section>
  )
}

export default FullheightMedia
